import type { ReactNode } from "react";
import { useDesign } from "./store";
import { DesignContext } from "./context";

export function DesignVersionProvider({ children }: { children: ReactNode }) {
  const version = useDesign((s) => s.version);
  return (
    <DesignContext.Provider value={version}>{children}</DesignContext.Provider>
  );
}
